module.exports = function (WaveformData, Utils) {
    'use strict';
    var isXhr2 = 'withCredentials' in new XMLHttpRequest();
    function WaveformBuilder(peaks) {
        this._peaks = peaks;
    }
    WaveformBuilder.prototype.init = function (options, callback) {
        if (options.dataUri && (options.webAudio || options.audioContext)) {
            throw new Error('Peaks.init(): You must pass a webAudio or dataUri to render waveform data, not both');
        }
        if (options.audioContext) {
            this._peaks.options.deprecationLogger('Peaks.init(): The audioContext option is deprecated, please pass a webAudio object instead');
            options.webAudio = { audioContext: options.audioContext };
        }
        if (options.dataUri) {
            return this._getRemoteWaveformData(options, callback);
        } else if (options.webAudio) {
            if (options.webAudio.audioBuffer) {
                return this._buildWaveformDataFromAudioBuffer(options, callback);
            } else {
                return this._buildWaveformDataUsingWebAudio(options, callback);
            }
        } else {
            throw new Error('Peaks.init(): You must pass an audioContext or dataUri to render waveform data');
        }
    };
    WaveformBuilder.prototype._getRemoteWaveformData = function (options, callback) {
        var self = this;
        var dataUri = null;
        var requestType = null;
        var url;
        if (Utils.isObject(options.dataUri)) {
            dataUri = options.dataUri;
        } else if (Utils.isString(options.dataUri)) {
            dataUri = {};
            dataUri[options.dataUriDefaultFormat || 'json'] = options.dataUri;
        } else {
            throw new Error('Peaks.init(): The dataUri option must be an object');
        }
        [
            'ArrayBuffer',
            'JSON'
        ].some(function (connector) {
            if (window[connector]) {
                requestType = connector.toLowerCase();
                url = dataUri[requestType];
                return Boolean(url);
            }
        });
        if (!url) {
            throw new Error('Peaks.init(): Unable to determine a compatible dataUri format for this browser');
        }
        var xhr = self._createXHR(url, requestType, options.withCredentials, function (event) {
            if (this.readyState !== 4) {
                return;
            }
            if (this.status !== 200) {
                callback(new Error('Unable to fetch remote data. HTTP status ' + this.status));
                return;
            }
            var waveformData = WaveformData.create(event.target.response);
            if (waveformData.channels !== 1 && waveformData.channels !== 2) {
                callback(new Error('Peaks.init(): Only mono or stereo waveforms are currently supported'));
                return;
            }
            callback(null, waveformData);
        }, function () {
            callback(new Error('XHR Failed'));
        });
        xhr.send();
    };
    WaveformBuilder.prototype._buildWaveformDataUsingWebAudio = function (options, callback) {
        var self = this;
        var audioContext = window.AudioContext || window.webkitAudioContext;
        if (!(options.webAudio.audioContext instanceof audioContext)) {
            throw new TypeError('Peaks.init(): The webAudio.audioContext option must be a valid AudioContext');
        }
        var webAudioOptions = options.webAudio;
        if (webAudioOptions.scale !== options.zoomLevels[0]) {
            webAudioOptions.scale = options.zoomLevels[0];
        }
        var mediaSourceUrl = self._peaks.player.getCurrentSource();
        if (mediaSourceUrl) {
            self._requestAudioAndBuildWaveformData(mediaSourceUrl, webAudioOptions, options.withCredentials, callback);
        } else {
            self._peaks.once('player_canplay', function (player) {
                self._requestAudioAndBuildWaveformData(player.getCurrentSource(), webAudioOptions, options.withCredentials, callback);
            });
        }
    };
    WaveformBuilder.prototype._buildWaveformDataFromAudioBuffer = function (options, callback) {
        var webAudioOptions = options.webAudio;
        if (webAudioOptions.scale !== options.zoomLevels[0]) {
            webAudioOptions.scale = options.zoomLevels[0];
        }
        var webAudioBuilderOptions = {
            audio_buffer: webAudioOptions.audioBuffer,
            split_channels: webAudioOptions.multiChannel,
            scale: webAudioOptions.scale
        };
        WaveformData.createFromAudio(webAudioBuilderOptions, callback);
    };
    WaveformBuilder.prototype._requestAudioAndBuildWaveformData = function (url, webAudio, withCredentials, callback) {
        var self = this;
        if (!url) {
            self._peaks.logger('Peaks.init(): The mediaElement src is invalid');
            return;
        }
        var xhr = self._createXHR(url, 'arraybuffer', withCredentials, function (event) {
            if (this.readyState !== 4) {
                return;
            }
            if (this.status !== 200) {
                callback(new Error('Unable to fetch remote data. HTTP status ' + this.status));
                return;
            }
            var webAudioBuilderOptions = {
                audio_context: webAudio.audioContext,
                array_buffer: event.target.response,
                split_channels: webAudio.multiChannel,
                scale: webAudio.scale
            };
            WaveformData.createFromAudio(webAudioBuilderOptions, callback);
        }, function () {
            callback(new Error('XHR Failed'));
        });
        xhr.send();
    };
    WaveformBuilder.prototype._createXHR = function (url, requestType, withCredentials, onLoad, onError) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        if (isXhr2) {
            try {
                xhr.responseType = requestType;
            } catch (e) {
            }
        }
        xhr.onload = onLoad;
        xhr.onerror = onError;
        if (isXhr2 && withCredentials) {
            xhr.withCredentials = true;
        }
        return xhr;
    };
    return WaveformBuilder;
}(require('waveform-data'), require('peaks/waveform/waveform.utils'));